import React, { useState } from 'react';
import FleetCarousel, { fleetSlides } from './FleetCarousel';

const GallerySection: React.FC = () => {
  const [lightbox, setLightbox] = useState<string | null>(null);

  return (
    <section className="section bg-gradient-to-br from-[#041528] via-[#062540] to-[#041528] text-white">
      <div className="text-center mb-12">
        <p className="font-marine uppercase tracking-[0.35em] text-primary-300 text-sm mb-3">
          Our Maritime Fleet
        </p>
        <h2 className="section-header text-white section-header--light">
          Our Fleet &amp; Operations
        </h2>
        <p className="text-lg text-blue-100/80 max-w-3xl mx-auto">
          Explore our extensive fleet of large ships and professional maritime operations
          supporting ship rental and charter services in Egyptian waters and ports.
        </p>
      </div>

      <FleetCarousel />

      {/* Compact fleet grid beneath the carousel */}
      <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
        {fleetSlides.slice(0, 4).map((item) => (
          <button
            key={item.id}
            type="button"
            className="group relative overflow-hidden rounded-2xl aspect-[4/3] ring-1 ring-white/10 hover:ring-primary-400/50 transition-all duration-300"
            onClick={() => setLightbox(item.src)}
          >
            <img
              src={item.src}
              alt={item.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#041528]/90 via-[#041528]/30 to-transparent transition-opacity duration-300 group-hover:opacity-0" />
            <div className="absolute bottom-0 left-0 right-0 p-4 text-left transition-opacity duration-300 group-hover:opacity-0">
              <p className="font-marine text-sm font-semibold text-white">{item.title}</p>
            </div>
            {/* Hover overlay — title + description */}
            <div className="absolute inset-0 flex flex-col justify-end p-4 bg-[#041528]/88 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
              <p className="font-marine text-sm font-semibold text-primary-300 mb-1">{item.title}</p>
              <p className="text-xs text-blue-100/90 leading-relaxed">{item.subtitle}</p>
            </div>
          </button>
        ))}
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
          role="dialog"
          aria-modal="true"
        >
          <div className="relative max-w-5xl max-h-full">
            <img
              src={lightbox}
              alt="Fleet photograph"
              className="max-w-full max-h-[85vh] object-contain rounded-xl"
            />
            <button
              type="button"
              onClick={() => setLightbox(null)}
              className="absolute top-4 right-4 bg-white/20 hover:bg-white/30 rounded-full p-2 text-white"
              aria-label="Close"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}

      <div className="text-center mt-16">
        <div className="p-8 max-w-2xl mx-auto rounded-2xl bg-[#062540]/90 border border-white/15 backdrop-blur-md shadow-xl">
          <h3 className="font-marine text-2xl font-bold text-white mb-4">
            Ready to Work With Us?
          </h3>
          <p className="text-blue-100 mb-6">
            Contact us today to discuss your offshore project requirements and discover
            how our professional services can support your operations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button type="button" className="btn-primary">
              Get Quote
            </button>
            <button
              type="button"
              className="font-semibold py-3 px-6 rounded-xl border-2 border-white/40 text-white hover:bg-white/15 transition-all duration-300"
            >
              View All Services
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
